module.exports = __webpack_public_path__ + "media/entities/2211-2f501577.png";